/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { etoilePercentage2 } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_multi_006: Question = {
  id: 'multi-006-coefficient-permeabilite',
  oldId: '67',
  title: 'Coefficient de perméabilité',
  number: '6.2',
  description: ['Coefficient de perméabilité, en ne comptabilisant que les ouvrages végétalisés'],
  type: QuestionType.INDICATOR,
  frequency: 1,
  slots: [
    {
      type: SlotTypes.ETOILES,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: true,
      scoringFct: (data:number) => {
        if (data >= 76) return 3;
        if (data >= 61) return 2;
        if (data >= 41) return 1;
        return 0;
      },
      score: '0',
      maxScore: 3,
      help: etoilePercentage2,
      unit: SlotUnit.PERCENTAGE,
    },
  ],
};

const question_multi_006__v3: Question = {
  ...question_multi_006,
  frequency: 4,
};

export const question_multi_006_v2: Question = question_multi_006;
export const question_multi_006_v3: Question = question_multi_006__v3;
